import { SET_FEATURED_PERK } from '../../actions/persist/featuredPerk';

const initialState = {
  perkId: null,
  nextRotationAt: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_FEATURED_PERK:
      return {
        ...state,
        perkId: action.payload.perkId,
        nextRotationAt: action.payload.nextRotationAt,
      };
    default:
      return state;
  }
};
